import { useRef } from 'react';

export const useMaxLength = maxLength => {
    const myRef = useRef();

    const amendInputValue = target => {
        const amendTarget = target || myRef.current;
        if (amendTarget.value.length > maxLength) {
            amendTarget.value = amendTarget.value.substring(0, maxLength);
        }
    };

    return {
        myRef,
        amendInputValue,
    };
};
